import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.context.request.user?.patient_profile ||
    !_setup.context.request.user.is_authenticated
    ? _c(
        "div",
        {
          staticClass:
            "d-flex align-center justify-center cursor-pointer bg-gray-0",
          style: _vm.size
            ? {
                width: `${_vm.size}px`,
                height: `${_vm.size}px`,
              }
            : undefined,
          attrs: {
            "data-qa": "favourite_btn",
            "data-qa-id": _vm.targetId,
            "data-qa-type": _vm.type,
          },
          on: { click: _setup.handleFavouriteClick },
        },
        [
          _setup.isLoading
            ? _c(VProgressCircular, {
                attrs: {
                  size: 20,
                  width: "2",
                  color: "primary",
                  indeterminate: "",
                },
              })
            : _c("span", {
                staticClass: "ui-icon-fz-medium",
                class: _setup.favouriteIconClass,
              }),
          _vm._v(" "),
          _c(_setup.CoreDialog, {
            attrs: {
              "data-qa": "favourite_btn_need_login_modal",
              size: "lg",
              title: _setup.t(
                "Необходимо войти в личный кабинет",
                _setup.options
              ),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            "data-qa": "favourite_btn_not_now_btn",
                            color: "text",
                            text: "",
                          },
                          on: {
                            click: function ($event) {
                              _setup.isOpenedNeedLogin = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.t("Не сейчас", _setup.options)) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            "data-qa": "favourite_btn_login_btn",
                            color: "primary",
                            text: "",
                          },
                          on: { click: _setup.goToLogin },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.t("Войти", _setup.options)) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              392802553
            ),
            model: {
              value: _setup.isOpenedNeedLogin,
              callback: function ($$v) {
                _setup.isOpenedNeedLogin = $$v
              },
              expression: "isOpenedNeedLogin",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }